// import GuestStatistics from 'App/GuestBook/Screens/Statistics';
// import ForgotPasswordContainer from 'App/Auth/Screens/ForgotPassword';
import LoginContainer from 'App/Auth/Screens/Login';
import DashboardContainer from 'App/Dashboard/Screens/Dashboard';
import TablePlan from 'App/ReservationBook/Screens/TablePlan';
import ReservationList from 'App/ReservationBook/Screens/ReservationList';
import TimeTable from 'App/ReservationBook/Screens/TimeTable';
import RegularTables from 'App/ReservationBook/Screens/RegularTables';
// import Feedback from 'App/Feedback/Screens/Feedback';
// import { default as TakeAwayAvailability } from 'App/TakeAway/Screens/MealAvailability';
// import Orders from 'App/TakeAway/Screens/Orders';

import LoadingScreen from 'Components/Atoms/LoadingScreen';
import LegacyBookkeepingRedirect from 'App/Bookkeeping/LegacyRedirect';
import { SHOP_ROUTE_PATHS } from 'App/Shop/routes';
import { withReloadOnChunkFailure } from 'utils/reloadOnChunkFailure';
import React, { Suspense, useContext, useEffect } from 'react';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom';
import { RestaurantContext } from 'Contexts/RestaurantContext';
import RestaurantDeletedScreen from 'App/Dashboard/Components/RestaurantDeletedScreen';
import CalendarScreen from 'App/Calendar/Screens/CalendarScreen';
// import { default as Voucher } from 'App/Voucher/Screens/General';
import { StylesProvider, useMediaQuery } from '@material-ui/core';
// import InvitationScreen from 'Components/Organisms/InvitationScreen';
import AddToHomeModal from 'App/Mobile/Components/AddToHomeModal';
import SupportPanel from 'Components/Organisms/SupportPanel';
import { SupportRequestProvider } from 'Contexts/SupportRequestContext';
import LargeGroupList from 'App/ReservationBook/Screens/LargeGroupList';
import VisitWishes from 'App/ReservationBook/Screens/VisitWishes';
import DragAndDropProvider from 'CustomHooks/useDragAndDrop';
import LoginWithGastronautContainer from 'App/Auth/Screens/LoginWithGastronaut';
// import MobileQuicklookContainer from 'App/Mobile/Screens/QuicklookPage';
// import MobileTablePlan from 'App/Mobile/Screens/Reservations/MobileTablePlan';
// import MinConsumptionsSettings from 'App/Settings/Screens/MinConsumptionsSettings/MinConsumptionsSettings';
// import CustomElements from 'App/Settings/Screens/CustomElements/CustomElements';

const ReactLazyWithSuspense = (factory: any) => {
  // The lazy component must be created once per route, outside the render
  // function below. React.lazy() returns a new component type every call, so
  // creating it per render makes React unmount and remount the entire screen
  // whenever the route re-renders (e.g. on any RestaurantContext update).
  const Component = React.lazy(withReloadOnChunkFailure(factory));

  return (params: any) => (
    <Suspense fallback={<LoadingScreen loading />}>
      <Component {...params} />
    </Suspense>
  );
};

const Voucher = ReactLazyWithSuspense(() => import('App/Voucher/Screens/V02'));

const VoucherTemplates = ReactLazyWithSuspense(
  () => import('App/Voucher/Screens/Templates'),
);

const VoucherFulfillment = ReactLazyWithSuspense(
  () => import('App/Voucher/Screens/Fulfillment'),
);

const ShopArea = ReactLazyWithSuspense(() => import('App/Shop'));
const ShopSettings = ReactLazyWithSuspense(() => import('App/Shop/Screens/Settings'));
const NoShowProtectionOverview = ReactLazyWithSuspense(
  () => import('App/NoShowProtection/Screens/Overview'),
);

const GuestBook = ReactLazyWithSuspense(
  () => import('App/GuestBook/Screens/GuestBook'), // import('App/GuestBook/Screens/GuestBookV02')
);

const GuestBookV02 = ReactLazyWithSuspense(
  () => import('App/GuestBook/Screens/GuestBookV02'), // import('App/GuestBook/Screens/GuestBookV02')
);

const ReservationGuestBook = ReactLazyWithSuspense(
  () => import('App/ReservationBook/Screens/GuestBook'),
);

const Feedback = ReactLazyWithSuspense(
  () => import('App/Feedback/Screens/Feedback'),
);

const Statistics = ReactLazyWithSuspense(
  () => import('App/ReservationBook/Screens/Statistics'),
);

const ForgotPasswordContainer = ReactLazyWithSuspense(
  () => import('App/Auth/Screens/ForgotPassword'),
);

const AuthAction = ReactLazyWithSuspense(
  () => import('App/Auth/Screens/AuthAction'),
);

const InvitationScreen = ReactLazyWithSuspense(
  () => import('Components/Organisms/InvitationScreen'),
);

const Orders = ReactLazyWithSuspense(
  () => import('App/TakeAway/Screens/Orders'),
);

const DigitalMenu = ReactLazyWithSuspense(
  () => import('App/DigitalMenu/Screens/DigitalMenu'),
);

const GuestStatistics = ReactLazyWithSuspense(
  () => import('App/GuestBook/Screens/Statistics'),
);

const TakeAwayAvailability = ReactLazyWithSuspense(
  () => import('App/TakeAway/Screens/MealAvailability'),
);

const MobileQuicklookContainer = ReactLazyWithSuspense(
  () => import('App/Mobile/Screens/QuicklookPage'),
);

const MobileTablePlan = ReactLazyWithSuspense(
  () => import('App/Mobile/Screens/Reservations/MobileTablePlan'),
);

const Experiences = ReactLazyWithSuspense(
  () => import('App/Experiences/Screens/Main'),
);

const Coupons = ReactLazyWithSuspense(() => import('App/Coupons'));

const ManagedWebsite = ReactLazyWithSuspense(() => import('App/Website'));

const Marketing = ReactLazyWithSuspense(
  () => import('App/Marketing/Screens/Main/Main')
);

const CampaignEditor = ReactLazyWithSuspense(
  () => import('App/Marketing/Screens/Editor/Editor')
);

const MinConsumptionsSettings = ReactLazyWithSuspense(
  () =>
    import(
      'App/Settings/Screens/MinConsumptionsSettings/MinConsumptionsSettings'
    ),
);

// const CalendarScreen = ReactLazyWithSuspense(
//   () => import('App/Calendar/Screens/CalendarScreen')
// );

const GeneralInformation = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/GeneralInformation'),
);
const IdentityScreen = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Identity'),
);
const IntegrationScreen = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Integration'),
);
const UserSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/UserSettings'),
);
const InvoiceTemplateSettingsScreen = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/InvoiceTemplateSettings'),
);
const Bookkeeping = ReactLazyWithSuspense(() => import('App/Bookkeeping'));
const GroupContainer = ReactLazyWithSuspense(() => import('App/Group'));
const IntegrationSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Integrations'),
);

const AppSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Apps'),
);
const EmailTemplates = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/EmailTemplates'),
);
const ReservationSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/ReservationSettingsNew'),
);
const EventTemplatesSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/EventTemplates'),
);
const TicketCancellationSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/TicketCancellationSettings'),
);
const FeedbackSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/FeedbackSettings'),
);
const FAQSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/FAQ'),
);
const ReservationIntegrationSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/ReservationIntegrationSettings'),
);
const Menues = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Menues'),
);
const Meals = ReactLazyWithSuspense(() => import('App/Settings/Screens/Meals'));
const Categories = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Categories'),
);
const Options = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Options'),
);
const TakeAwaySettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/TakeAwaySettings'),
);
const TakeAwayShifts = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/TakeAwayShifts'),
);
const VoucherSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/VoucherSettings'),
);
const FloorPlanSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/FloorPlanSettings'),
);
const MobileSupport = ReactLazyWithSuspense(
  () => import('App/Mobile/Screens/Support'),
);
const ImagesSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/ImagesSettings'),
);
const ProfileSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/ProfileSettings'),
);
const SignatureSettings = ReactLazyWithSuspense(
  () => import('./App/Settings/Screens/SignatureSettings/SignatureSettings'),
);
const WebsiteSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/WebsiteSettings'),
);
const WebsitePages = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/WebsitePages'),
);
const WebsiteEvents = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/WebsiteEvents'),
);
const NewRestaurant = ReactLazyWithSuspense(
  () => import('App/Onboarding/Screens/NewRestaurant'),
);
const StatisticsQuotaSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/StatisticsQuotaSettings'),
);
const PreviewContainer = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/Preview'),
);
const GuestAndResaImport = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/GuestAndResaImport'),
);
const ReservationLinksSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/ReservationLinks'),
);
const ProductsLinkstreeSettingsContainer = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/ProductsLinksSettings'),
);
const LinktreeSettingsContainer = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/LinktreeSettings'),
);
const GuestOrderingGeneral = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/GuestOrderingGeneral'),
);
const GuestOrderingPayment = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/GuestOrderingPayment'),
);
const GuestOrderingCallWaiter = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/GuestOrderingCallWaiter'),
);
const GuestOrderingStations = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/GuestOrderingStations'),
);
const SiaCurrentDay = ReactLazyWithSuspense(
  () => import('App/Dashboard/Screens/SiaCurrentDay'),
);
const SiaEmbedSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/SiaEmbedSettings'),
);
const SiaEmbed = ReactLazyWithSuspense(
  () => import('App/Dashboard/Screens/SiaEmbed'),
);
const SettingsHome = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/SettingsHome'),
);
const LightReservation = ReactLazyWithSuspense(
  () => import('App/ReservationBook/Screens/LightReservation'),
);
const RouteManager = ReactLazyWithSuspense(
  () => import('App/TakeAway/Screens/RouteManager'),
);
const NewOrder = ReactLazyWithSuspense(
  () => import('App/TakeAway/Screens/NewOrder'),
);
const Accounting = ReactLazyWithSuspense(
  () => import('App/TakeAway/Screens/Accounting'),
);
const EntranceTicket = ReactLazyWithSuspense(
  () => import('App/Mobile/Screens/EntranceTicket'),
);
const TicketDoor = ReactLazyWithSuspense(() => import('App/TicketDoor'));
const TicketSalesOverview = ReactLazyWithSuspense(
  () => import('App/Tickets/TicketSalesOverview'),
);
const AppStore = ReactLazyWithSuspense(
  () => import('App/Apps/Screens/General'),
);

const SiaSettingsScreen = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/SiaSettings'),
);

const CustomElementSettings = ReactLazyWithSuspense(
  () => import('App/Settings/Screens/CustomElements'),
);

const RESTAURANT_ID_PLACEHOLDER = ':restaurantId';

const RestaurantIdRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (!pathname.includes(RESTAURANT_ID_PLACEHOLDER)) return;

    try {
      const raw = window.localStorage.getItem('restaurantId');
      const restaurantId = raw ? JSON.parse(raw)?.value : null;
      if (restaurantId) {
        history.replace(
          pathname.replace(RESTAURANT_ID_PLACEHOLDER, restaurantId) +
            search +
            hash,
        );
      } else {
        history.replace('/');
      }
    } catch {
      // localStorage read/parse failed — do nothing
    }
  }, [pathname, search, hash, history]);

  return null;
};

const DELETED_GATE_EXCLUDED_PREFIXES = [
  '/auth',
  '/__/auth/',
  '/loginWithGastronaut',
  '/onboarding',
  '/m/',
  '/group/',
];

const DeletedGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { restaurantId, deleted, deletedAt } = useContext(RestaurantContext);
  const { pathname } = useLocation();

  const isExcluded = DELETED_GATE_EXCLUDED_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  );

  if (restaurantId && deleted && !isExcluded) {
    return (
      <RestaurantDeletedScreen
        restaurantId={restaurantId}
        deletedAt={deletedAt}
      />
    );
  }

  return <>{children}</>;
};

// Desktop uses the inset panel, so a direct hit on the mobile support route
// opens the panel and returns to the dashboard home.
const DesktopSupportRedirect = () => {
  // Read the id from the URL, not context — the context's restaurantId can
  // still be null while auth/restaurant state initializes on a direct load.
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const { setSupportOpen } = useContext(RestaurantContext);
  const history = useHistory();
  // Open the panel and redirect in a single effect so the panel-open isn't lost
  // to a <Redirect> unmounting this component before the effect runs.
  useEffect(() => {
    setSupportOpen(true);
    history.replace(restaurantId ? `/${restaurantId}` : '/');
  }, [setSupportOpen, history, restaurantId]);
  return null;
};

const Router = () => {
  // noSsr so isMobile is correct on the FIRST render. Without it useMediaQuery
  // returns false initially, which on mobile briefly renders the desktop-only
  // branches (the support redirect, the inset panel) — causing a redirect
  // bounce off /support and mount/unmount churn (flicker + repeated logs).
  const isMobile = useMediaQuery('(max-width:450px)', { noSsr: true });
  const { supportOpen, restaurantId } = useContext(RestaurantContext);

  // if (isMobile) {
  //   return <InvitationScreen />;
  // }

  return (
    <StylesProvider injectFirst>
      <DragAndDropProvider>
        <>
          <RestaurantIdRedirect />
          <AddToHomeModal />
          <SupportRequestProvider isMobile={isMobile}>
          <div className="app-shell">
            <div className="app-main">
          <DeletedGate>
          <Switch>
            <Suspense fallback={<LoadingScreen loading />}>
              <Route
                path="/m/quicklook"
                component={MobileQuicklookContainer}
                exact
              />

              <Route path="/" component={DashboardContainer} exact />
              <Route path="/auth/login" component={LoginContainer} exact />
              <Route
                path="/loginWithGastronaut"
                component={LoginWithGastronautContainer}
                exact
              />
              <Route
                path="/auth/forgot-password"
                component={ForgotPasswordContainer}
                exact
              />
              {/* Target of the custom action URL configured in Firebase Auth;
                  every password-reset and sign-in-link mail points here. */}
              <Route path="/__/auth/action" component={AuthAction} exact />
              <Route
                path="/onboarding/:templateId/:sessionId"
                component={NewRestaurant}
                exact
              />
              <Route
                path="/group/:groupId/:tab?"
                component={GroupContainer}
                exact
              />
              <Route
                path="/:restaurantId"
                component={DashboardContainer}
                exact
              />
              <Route
                path="/:restaurantId/support"
                component={isMobile ? MobileSupport : DesktopSupportRedirect}
                exact
              />
              <Route
                path="/:restaurantId/entranceTicket"
                component={EntranceTicket}
                exact
              />
              <Route path="/:restaurantId/ticketDoor" component={TicketDoor} exact />
              <Route
                path="/:restaurantId/calendar/:date"
                component={CalendarScreen}
                exact
              />
              <Route
                path="/:restaurantId/sia"
                component={SiaCurrentDay}
                exact
              />
              <Route
                path="/:restaurantId/sia-embed"
                component={SiaEmbed}
                exact
              />

              <Route path="/:restaurantId/apps" component={AppStore} exact />

              <Route
                path="/:restaurantId/reservations/:date/tablePlan"
                component={isMobile ? MobileTablePlan : TablePlan}
                exact
              />
              {/* ReservationList */}
              <Route
                path="/:restaurantId/reservations/:date/list"
                component={ReservationList}
                exact
              />
              <Route
                path="/:restaurantId/reservations/:date/reservationList"
                component={LightReservation}
                exact
              />
              <Route
                path="/:restaurantId/reservations/:date/timeTable"
                component={TimeTable}
                exact
              />
              <Route
                path="/:restaurantId/reservations/:date/statistics"
                component={Statistics}
                exact
              />
              <Route
                path="/:restaurantId/reservations/largeGroups"
                component={LargeGroupList}
                exact
              />
              <Route
                path="/:restaurantId/reservations/regularTables"
                component={RegularTables}
                exact
              />
              <Route
                path="/:restaurantId/reservations/visitWishes"
                component={VisitWishes}
                exact
              />
              <Route
                path="/:restaurantId/experiences"
                component={Experiences}
                exact
              />
              <Route
                path="/:restaurantId/bookkeeping/:section?"
                component={Bookkeeping}
                exact
              />
              <Route
                path="/:restaurantId/experiences/purchases"
                render={() => <LegacyBookkeepingRedirect section="add-ons" />}
                exact
              />
              <Route path="/:restaurantId/coupons" component={Coupons} exact />
              <Route path="/:restaurantId/website" component={ManagedWebsite} exact />

              <Route
                path="/:restaurantId/marketing/new"
                component={CampaignEditor}
                exact
              />

              <Route
                path="/:restaurantId/marketing/edit/:campaignId"
                component={CampaignEditor}
                exact
              />

              <Route
                path="/:restaurantId/marketing"
                component={Marketing}
                exact
              />

              <Route
                path="/:restaurantId/reservations/:date/guestbook"
                component={ReservationGuestBook}
                exact
              />
              <Route
                path="/:restaurantId/guestbook"
                component={GuestBook}
                exact
              />
              <Route
                path="/:restaurantId/guestbookV02"
                component={GuestBookV02}
                exact
              />
              <Route
                path="/:restaurantId/statistics"
                component={GuestStatistics}
                exact
              />
              <Route
                path="/:restaurantId/platform-preview"
                component={PreviewContainer}
                exact
              />
              <Route
                path="/:restaurantId/takeAway/orders/:date"
                component={Orders}
                exact
              />
              <Route
                path="/:restaurantId/takeAway/routeManager/:date"
                component={RouteManager}
                exact
              />
              <Route
                path="/:restaurantId/takeAway/accounting/:date"
                component={Accounting}
                exact
              />
              <Route
                path="/:restaurantId/takeAway/meal-availability/:date"
                component={TakeAwayAvailability}
                exact
              />
              <Route
                path="/:restaurantId/takeAway/newOrder"
                component={NewOrder}
                exact
              />
              <Route path="/:restaurantId/menu" component={DigitalMenu} exact />
              <Route
                path="/:restaurantId/feedback"
                component={Feedback}
                exact
              />
              <Route path="/:restaurantId/vouchers" component={Voucher} exact />
              <Route
                path="/:restaurantId/vouchers/purchases"
                render={() => <LegacyBookkeepingRedirect section="vouchers" />}
                exact
              />
              <Route
                path="/:restaurantId/vouchers/templates"
                component={VoucherTemplates}
                exact
              />
              <Route
                path="/:restaurantId/vouchers/fulfillment"
                component={VoucherFulfillment}
                exact
              />
              <Route
                path="/:restaurantId/no-show-protection"
                component={NoShowProtectionOverview}
                exact
              />
              <Route path={SHOP_ROUTE_PATHS} component={ShopArea} exact />
              {/* </Suspense>
            Settings Routes 
          <Suspense fallback={<LoadingScreen loading />}> */}
              <Route
                path="/:restaurantId/settings"
                component={isMobile ? InvitationScreen : SettingsHome}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/general-information"
                component={GeneralInformation}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/identity"
                component={IdentityScreen}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/integration"
                component={IntegrationScreen}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/users"
                component={UserSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/signatures"
                component={SignatureSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/invoice-template"
                component={InvoiceTemplateSettingsScreen}
                exact
              />
              <Route
                path="/:restaurantId/settings/billing/hyperline"
                render={() => <LegacyBookkeepingRedirect section="hyperline" />}
                exact
              />
              <Route
                path="/:restaurantId/settings/billing/customer-invoices"
                render={() => <LegacyBookkeepingRedirect section="customer-invoices" />}
                exact
              />
              {/* <Route
                path="/:restaurantId/settings/general/billing"
                component={BillingSettings}
                exact
              /> */}
              {/* <Route
              path="/:restaurantId/settings/general/integrations"
              component={IntegrationSettings}
              exact
            /> */}
              <Route
                path="/:restaurantId/settings/general/apps"
                component={AppSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/email-templates"
                component={EmailTemplates}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/images"
                component={ImagesSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/profile-settings"
                component={ProfileSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/sia"
                component={SiaSettingsScreen}
                exact
              />
              <Route
                path="/:restaurantId/settings/sia-embed"
                component={SiaEmbedSettings}
                exact
              />
              {/* <Route
              path="/:restaurantId/settings/reservations/sms-notifications"
              component={SmsSettingsContainer}
              exact
            /> */}
              <Route
                path="/:restaurantId/settings/reservations/reservation-settings"
                component={ReservationSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/reservations/event-templates"
                component={EventTemplatesSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/reservations/ticket-cancellation"
                component={TicketCancellationSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/reservations/statistics"
                component={StatisticsQuotaSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/reservations/table-plans"
                component={FloorPlanSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/reservations/feedback"
                component={FeedbackSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/faqs"
                component={FAQSettings}
                exact
              />

              <Route
                path="/:restaurantId/settings/reservations/integration"
                component={ReservationIntegrationSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/reservations/import-guest"
                component={GuestAndResaImport}
                exact
              />
              <Route
                path="/:restaurantId/settings/reservations/reservation-links"
                component={ReservationLinksSettings}
                exact
              />
              {/* <Route
              path="/:restaurantId/settings/reservations/min-consumptions"
              component={MinConsumptionsSettings}
              exact
            /> */}
              <Route
                path="/:restaurantId/settings/reservations/customElements"
                component={CustomElementSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/meals/menues"
                component={Menues}
                exact
              />
              <Route
                path="/:restaurantId/settings/meals/items-categories"
                component={Meals}
                exact
              />
              {/* <Route
              path="/:restaurantId/settings/meals/categories"
              component={Categories}
              exact
            /> */}
              {/* <Route
              path="/:restaurantId/settings/meals/options"
              component={Options}
              exact
            /> */}
              <Route
                path="/:restaurantId/settings/delivery/takeaway-settings"
                component={TakeAwaySettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/delivery/opening"
                component={TakeAwayShifts}
                exact
              />
              <Route
                path="/:restaurantId/settings/guest-ordering/general"
                component={GuestOrderingGeneral}
                exact
              />
              <Route
                path="/:restaurantId/settings/guest-ordering/payment"
                component={GuestOrderingPayment}
                exact
              />
              <Route
                path="/:restaurantId/settings/guest-ordering/call-waiter"
                component={GuestOrderingCallWaiter}
                exact
              />
              <Route
                path="/:restaurantId/settings/guest-ordering/stations"
                component={GuestOrderingStations}
                exact
              />
              <Route
                path="/:restaurantId/settings/vouchers/settings"
                component={VoucherSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/general/shop"
                component={ShopSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/links/products-links"
                component={ProductsLinkstreeSettingsContainer}
                exact
              />
              <Route
                path="/:restaurantId/settings/links/linktree"
                component={LinktreeSettingsContainer}
                exact
              />
              <Route
                path="/:restaurantId/settings/website/website-settings"
                component={WebsiteSettings}
                exact
              />
              <Route
                path="/:restaurantId/settings/website/pages"
                component={WebsitePages}
                exact
              />
              <Route
                path="/:restaurantId/settings/website/events"
                component={WebsiteEvents}
                exact
              />
              <Route
                path="/:restaurantId/tickets/:date/sales-overview"
                component={TicketSalesOverview}
                exact
              />
            </Suspense>
          </Switch>
          </DeletedGate>
            </div>
            {supportOpen && restaurantId && !isMobile && <SupportPanel />}
          </div>
          </SupportRequestProvider>
        </>
      </DragAndDropProvider>
    </StylesProvider>
  );
};

export default Router;
